import clsx from "clsx";

import { GeneralLink } from "@customTypes/generalLink";
import slugify from "@utilities/slugify";
import C270_CtaContainerLink from "./C270_CtaContainerLink";
import C270_GatedCtaContainerLink, {
  CtaLink,
} from "./C270_GatedCtaContainerLink";

import styles from "./C270_CtaContainer.module.scss";

export interface CtaContainerProps {
  ctaContent: [
    {
      fields: {
        cta: GeneralLink;
        description: string;
      };
      component: string;
    } & CtaLink,
  ];
  title: string;
  variation?: "primary" | "blue" | "think-blue";
}

export const CtaContainer = (props: { content: CtaContainerProps }) => {
  const { content } = props;
  const { ctaContent, title, variation = "blue" } = content;
  const ariaDesribedBy = title ? `cta-container-${slugify(title)}` : undefined;

  return (
    <div className={clsx(styles["cta-container"], styles[variation])}>
      <div className={clsx(styles["cta-container__section"], "wrapper")}>
        <h3 className={styles["cta-container__heading"]} id={ariaDesribedBy}>
          {title}
        </h3>
        <div className="flex flex-col md:flex-row justify-center gap-12">
          {ctaContent.map((ctaData, index) =>
            ctaData?.component === "gatedCtaContent" ? (
              // @ts-expect-error type mistmatch
              <C270_GatedCtaContainerLink
                key={`${ctaData.fields?.cta?.fields?.linkText}${index}`}
                ctaContent={ctaData}
                isBlue={variation === "blue"}
              />
            ) : (
              // @ts-expect-error type mistmatch
              <C270_CtaContainerLink
                ariaDescribedBy={ariaDesribedBy}
                key={`${ctaData.fields?.cta?.fields?.linkText}${index}`}
                ctaContent={ctaData}
                isBlue={variation === "blue"}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default CtaContainer;
